:host {
  @apply inline-block;
}

::slotted(img) {
  @apply w-full h-full object-cover;
}

::slotted(picture) {
  @apply flex w-full h-auto overflow-hidden;
}

::slotted(img),
::slotted(picture) {
  @apply w-full rounded-t min-h-[1px];
}

div.action {
  @apply absolute bg-white rounded-t-[5px] left-0 right-0 py-[15px] px-[30px] transition-[bottom] duration-[750ms] ease-out shadow-[0_-14px_15px_-10px_rgba(0,0,0,0.15)] z-[33];
}

.animated-dots {
  &:hover {
    .dot-left {
      @apply animate-dotLeft;
    }
    .dot-middle {
      @apply animate-dotMiddle;
    }
    .dot-right {
      @apply animate-dotRight;
    }
  }
}

slot[name="read-more"] {
  @apply flex flex-[1];
}
